import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Tabs, Tab, makeStyles, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './TabbedWorkspaceContainer.module.css';
import { DISPLAY_MESSAGES } from '../../constants';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  },
  body: {
    flex: 1,
    display: 'inline-block',
    paddingTop: '1.5em',
    backgroundColor: props => (props.isAggregate ? 'rgb(243, 245, 249)' : null),
    height: 'calc(97vh - 52px - 1.5em)',
  },
  sidePanel: {
    display: 'inline-block',
    maxWidth: '5vw',
    marginTop: '16px',
  },

  line: {
    width: '1px',
    height: '100%',
    background: '#e8eff7',
    position: 'fixed',
    right: '64px',
    top: '0',
    zIndex: '0',
  },
});

const Panel = ({ children, value, index }) => {
  if (index !== value) return <div style={{ display: 'none' }} />;
  return <>{children}</>;
};

const TabbedWorkspace = ({ tabs, isAggregate, isJlr }) => {
  const [tabVal, setTabVal] = useState(0);
  const [hasActiveEdits, setHasActiveEdits] = useState(false);

  const handleTabChange = (value, isInEdit) => {
    let shouldChangeTab = true;
    if (isInEdit) {
      shouldChangeTab = window.confirm(DISPLAY_MESSAGES.NAVIGATION_WARNING);
    }
    if (shouldChangeTab) {
      setTabVal(value);
    }
  };

  const CustomizedTabs = withStyles({
    indicator: {
      backgroundColor: isJlr && '#26662E',
    },
  })(Tabs);

  useEffect(() => {
    setHasActiveEdits(false);
  }, [tabVal]);

  return (
    <div className={styles.workspace}>
      <div
        className={clsx(styles.tabBar, isAggregate && styles.aggregateTabBar)}
      >
        <CustomizedTabs
          value={tabVal}
          onChange={(e, value) => handleTabChange(value, hasActiveEdits)}
          aria-label="workspace type selection tabs"
          className={styles.tabs}
          indicatorColor="primary"
          TabIndicatorProps={{
            style: { display: isAggregate ? 'none' : null },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              className={clsx(
                styles.tab,
                isAggregate
                  ? tabVal !== index
                    ? styles.inactiveTab
                    : styles.activeTab
                  : null,
              )}
              label={tab.label}
            />
          ))}
        </CustomizedTabs>
      </div>
      {tabs.map((tab, index) => (
        <Panel value={tabVal} index={index}>
          <tab.component
            {...tab.props}
            hasActiveEdits={hasActiveEdits}
            setHasActiveEdits={setHasActiveEdits}
          />
        </Panel>
      ))}
    </div>
  );
};

const TabbedWorkspaceContainer = props => {
  const classes = useStyles(props);
  const { tabs, isAggregate, isJlr } = props;

  return (
    <>
      <div className={classes.container}>
        <div className={classes.body}>
          <TabbedWorkspace
            isAggregate={isAggregate}
            tabs={tabs}
            isJlr={isJlr}
          />
        </div>
      </div>
    </>
  );
};

TabbedWorkspaceContainer.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.node.isRequired,
      props: PropTypes.object,
    }),
  ).isRequired,
  pageTitle: PropTypes.string.isRequired,
  isAggregate: PropTypes.bool,
  isJlr: PropTypes.bool,
};

export default TabbedWorkspaceContainer;
